// src/modules/auth/AuthErrorHandling/AuthErrorUtil.ts

import { AuthErrorKeys } from "./AuthErrorEnum";

function getAuthErrorMessage(errorKey: string,defaultMessage:string): string {
  if (errorKey.startsWith("needLoginViaProvider")) {
    const provider = errorKey.split(":")[1];
    return `Please login using your ${provider} account.`;
  }

  return (
    (AuthErrorKeys as any)[errorKey] ||
   defaultMessage
  );
}

export { getAuthErrorMessage };
